import { FormGroup, ValidatorFn } from '@angular/forms';

export function resetFormControls(form: FormGroup, fields: string[]): void {
	fields.forEach((field) => form.get(field)?.reset());
}

export function enableFormControls(form: FormGroup, fields: string[]): void {
	fields.forEach((field) => form.get(field)?.enable());
}

export function disableFormControls(form: FormGroup, fields: string[]): void {
	fields.forEach((field) => form.get(field)?.disable());
}

export function setValidators(form: FormGroup, fields: string[], validators: ValidatorFn[]): void {
	fields.forEach((field) => form.get(field)?.setValidators(validators));
	for (const field of fields) {
		form.get(field)?.updateValueAndValidity();
	}
}

export function clearAllValidators(form: FormGroup, fields: string[]): void {
	fields.forEach((field) => form.get(field)?.clearValidators());
	for (const field of fields) {
		form.get(field)?.updateValueAndValidity();
	}
}
